import type { IErrorResponse, ProductCommentPayload } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useSendProductComment = (): UseMutationResult<
  [],
  IErrorResponse,
  ProductCommentPayload
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.productComments, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('yourCommentSuccessfullyRegistered'),
      });
    },
  });
};

export default useSendProductComment;
